export function escapeHTML(value) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll("\"", "&quot;");
}

export function renderSkeleton(lines = 3) {
  return `<div class="skeleton">${Array.from({ length: lines }, () => '<div class="skeleton__line"></div>').join("")}</div>`;
}

export function renderEmptyState(title, description, actionHTML = "") {
  return `
    <div class="empty-state">
      <div class="empty-state__title">${escapeHTML(title)}</div>
      <div class="empty-state__description">${escapeHTML(description)}</div>
      ${actionHTML}
    </div>
  `;
}

export function renderContextStrip(items) {
  return `
    <div class="context-strip">
      ${items.map((item, i) => `
        ${i > 0 ? '<span class="context-strip__sep"></span>' : ""}
        <span class="context-chip">
          <span class="context-chip__label">${escapeHTML(item.label)}</span>
          <span class="context-chip__value">${escapeHTML(item.value)}</span>
        </span>
      `).join("")}
    </div>
  `;
}

export function renderMessageContent(text) {
  let html = escapeHTML(text);
  html = html.replace(/```([\s\S]*?)```/g, '<pre class="inline-code-block">$1</pre>');
  html = html.replace(/`([^`]+)`/g, '<code class="inline-code">$1</code>');
  html = html.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
  html = html.replace(/\*([^*]+)\*/g, "<em>$1</em>");
  html = html.replace(/\n\n+/g, "</p><p>");
  html = html.replace(/\n/g, "<br>");
  return `<p>${html}</p>`;
}

export function truncateIDText(fullID, chars = 12) {
  return String(fullID || "").slice(0, chars);
}

export function renderTruncatedID(fullID, chars = 8) {
  const short = truncateIDText(fullID, chars);
  return `<span class="truncated-id" title="${escapeHTML(fullID)}">${escapeHTML(short)}</span>`;
}

export function renderTabs(tabs, activeID) {
  return `
    <div class="tab-bar" role="tablist">
      ${tabs.map((tab) => `
        <button class="tab-bar__item ${tab.id === activeID ? "tab-bar__item--active" : ""}" role="tab" data-tab="${escapeHTML(tab.id)}">
          ${escapeHTML(tab.label)}${tab.count != null ? ` <span class="tab-bar__count">${tab.count}</span>` : ""}
        </button>
      `).join("")}
    </div>
  `;
}

export function renderContextRow(label, value) {
  return `
    <article class="table-row">
      <div class="metric-label">${escapeHTML(label)}</div>
      <div class="summary-card__value mono">${escapeHTML(value)}</div>
    </article>
  `;
}

export function formatTimestamp(value) {
  if (!value) {
    return "n/a";
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return String(value);
  }
  return date.toLocaleString();
}

export function formatBytes(bytes) {
  const value = Number(bytes || 0);
  if (value === 0) {
    return "0 B";
  }
  const units = ["B", "KB", "MB", "GB"];
  let current = value;
  let unit = 0;
  while (current >= 1024 && unit < units.length - 1) {
    current /= 1024;
    unit += 1;
  }
  return `${current.toFixed(current >= 10 || unit === 0 ? 0 : 1)} ${units[unit]}`;
}

export function timeAgo(value) {
  if (!value) {
    return "";
  }
  const ms = Date.now() - new Date(value).getTime();
  if (Number.isNaN(ms) || ms < 0) {
    return "";
  }
  const sec = Math.floor(ms / 1000);
  if (sec < 60) {
    return "now";
  }
  const min = Math.floor(sec / 60);
  if (min < 60) {
    return `${min}m`;
  }
  const hr = Math.floor(min / 60);
  if (hr < 24) {
    return `${hr}h`;
  }
  const days = Math.floor(hr / 24);
  return `${days}d`;
}
